<template>
    <div class="content" v-loading.fullscreen.lock="loading">
        <!-- <div class="content-c">
            <el-form ref="form" label-width="130px" :model="form" :label-position="labelPosition">
                <el-form-item label="删除地区code:" prop="id">
                    <el-input v-model="form.id" placeholder="请输入code"></el-input>
                </el-form-item>
            </el-form>
            <el-button style="float:right;margin-top:20px" @click="open">删除</el-button>
        </div> -->
    </div>
</template>

<script>
    import { remove } from '@/api/zone.js'
    export default {
        data() {
            return {
                form: {
                    id: '',
                },
                labelPosition: 'left',
                loading: false
            }
        },
        created() {
            this.open()
        },
        methods: {
            open() {
                this.$confirm("此操作将永久删除项目, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.setUp();
                    })
                    .catch(() => { });
            },
            // 删除
            async setUp() {
                let removeRes = await remove({
                    id: this.$cookies.get('zone')
                })
                if (removeRes.status == 0) {
                    this.$message.success('删除成功!')
                    this.form = {}
                    this.loading = false
                }
            },
        }
    }
</script>

<style scoped>
    .content {
        padding-top: 100px;
        margin: 0 auto;
    }

        .content .content-c {
            width: 500px;
        }
</style>